import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import breakpoints from "../../shared/constants";

const StyledList = styled.ul`
  padding-left: 0;

  column-count: 2;
  column-gap: 4rem;

  @media (min-width: ${breakpoints.DESKTOP}) {
    column-gap: ${({ footerNavigationConfig }) =>
      footerNavigationConfig.columnGap || "50px"};
    column-count: ${({ footerNavigationConfig }) =>
      footerNavigationConfig.columnCount || "2"};
  }

  li {
    list-style: none;
  }
`;

function NavigationColumns(props) {
  const {
    navigationLinks,
    navigationItemClassName = "mb-4",
    listClassName = "mb-5",
  } = props;

  const { footerStore } = useStores();
  const { additionalConfiguration } = footerStore;

  if (isEmpty(navigationLinks)) {
    return null;
  }

  const listItemClassName = classNames(
    "text-uppercase",
    navigationItemClassName
  );

  return (
    <StyledList
      className={listClassName}
      footerNavigationConfig={additionalConfiguration?.footerNavigation || {}}
    >
      {navigationLinks.map((column) => {
        const href = column.path ? `/${column.path}` : column.externalPath;
        return (
          <li key={`${column.title}`} className={listItemClassName}>
            <a href={href}>{column.title}</a>
          </li>
        );
      })}
    </StyledList>
  );
}

export default observer(NavigationColumns);

NavigationColumns.propTypes = {
  listClassName: PropTypes.string,
  navigationItemClassName: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({ externalPath: PropTypes.string, title: PropTypes.string })
  ).isRequired,
};

NavigationColumns.defaultProps = {
  listClassName: "mb-5",
  navigationItemClassName: "mb-4",
};
